<template>
    <p v-if="error" class="help is-danger">{{ error }}</p>
</template>

<script>
    // simple component to display errors
    // beside custom inputs (e.g. quill-editor)
    export default {
        props: ['error']
    }
</script>